module.exports = __webpack_public_path__ + "img/pg.d2ad1883.svg";